export const getEnvType = () => {
  const def = "local";
  const envType = document.getElementById("envType")?.innerHTML;
  if (!envType || envType === "") {
    return process.env.REACT_APP_ENV_TYPE ?? def;
  }
  return envType;
};

export const getLogoText = () => {
  const def = "A.P.J.";
  const envType = getEnvType();
  let logoText = document.getElementById("logoText")?.innerHTML;
  if (!logoText || logoText === "") {
    logoText = process.env.REACT_APP_LOGO_TEXT ?? def;
  }
  if (envType === "production") return logoText;
  return `${logoText} -- ${envType} --`;
};

export const getApiUrl = () => {
  const def = "http://localhost:8001/api";
  const apiUrl = document.getElementById("apiUrl")?.innerHTML;
  if (!apiUrl || apiUrl === "") {
    return process.env.REACT_APP_API_URL ?? def;
  }
  return apiUrl;
};
